import { defineMessage } from 'services/localization';

export const messages = {
    optionPasskeys: defineMessage('passkeys_and_security_keys'),
    optionPasskeysUnavailable: defineMessage('with_passkeys_you_can_s_t_only_you_can_use_them'),
    buttonSetup: defineMessage('setup'),
    buttonAddPasskey: defineMessage('add_passkey'),
    buttonAddSecurityKey: defineMessage('add_security_key'),
    alertRemovePasskey: defineMessage('please_setup_password_o_passkey_or_security_key'),
};
